export default __webpack_public_path__ + "static/media/date-arrow-left.dfa1ae36.svg";